export class MailService {

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./app/core/services/mail/mail.service.ts